import { commonUtils } from '@/helpers/commonUtils'
import { routerService } from '@/services/routerService'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import { CSSProperties, useCallback, useEffect, useRef, useState } from 'react'
import style from './CountDownV2.module.less'

type CountDownV2Props = {
  open: boolean
  end: number
  clickable?: boolean
  hideArrow?: boolean
  descText?: string
  discountText?: string
  discountPercent?: number
  className?: string
  styleCSS?: CSSProperties
  timeEnd?: () => void
}

const CountDownV2 = observer((props: CountDownV2Props) => {
  const {
    open,
    className,
    styleCSS = {},
    end,
    timeEnd,
    hideArrow = false,
    clickable = true,
    descText = '',
    discountText = '',
    discountPercent = 50,
  } = props

  const timerId = useRef<NodeJS.Timeout | string | number | undefined>(undefined)
  const timeEndRef = useRef(timeEnd)
  const [timeObj, setTimeObj] = useState<{
    hourStr: string
    minuteStr: string
    secondStr: string
  }>({
    hourStr: '',
    minuteStr: '',
    secondStr: '',
  })

  // 保持timeEndRef始终指向最新的timeEnd回调
  useEffect(() => {
    timeEndRef.current = timeEnd
  }, [timeEnd])

  const countdown = useCallback((end: number) => {
    const now = Date.now()

    if (end <= now) {
      setTimeObj({
        hourStr: '00',
        minuteStr: '00',
        secondStr: '00',
      })
      timeEndRef.current?.()
      return
    }

    const processTime = (t: number) => {
      return t < 10 ? `0${t}` : t + ''
    }

    const counter = () => {
      let diff = Math.floor((end - Date.now()) / 1000)
      if (diff < 0) {
        diff = 0
      }
      const hours = Math.floor(diff / 3600)
      const minutes = Math.floor((diff / 60) % 60)
      const seconds = Math.floor(diff % 60)
      setTimeObj({
        hourStr: processTime(hours),
        minuteStr: processTime(minutes),
        secondStr: processTime(seconds),
      })
      timerId.current = setTimeout(() => {
        if ([hours, minutes, seconds].every((num) => num === 0)) {
          clearTimeout(timerId.current)
          timeEndRef.current?.()
          return
        }
        counter()
      }, 1000)
    }

    counter()
  }, [])

  useEffect(() => {
    if (open) {
      countdown(end)
    }

    return () => {
      clearTimeout(timerId.current)
      timerId.current = undefined
    }
  }, [open, end])

  if (!open) {
    return null
  }

  return (
    <section
      className={classNames(style.countDownV2, className)}
      onClick={() => {
        if (clickable) {
          routerService.openNewTab('pricing')
        }
      }}
      style={styleCSS}
    >
      <img
        className={classNames(style.leftIcon)}
        src={commonUtils.getStaticFile('new_count_down_alert.png')}
      />

      <div className={style.timeBox}>
        <div className={style.timeNumber}>{timeObj.hourStr}</div>
        <div className={style.unit}>时</div>
        <div className={style.timeNumber}>{timeObj.minuteStr}</div>
        <div className={style.unit}>分</div>
        <div className={style.timeNumber}>{timeObj.secondStr}</div>
        <div className={style.unit}>秒</div>
      </div>

      <div className={classNames(style.textBox)}>
        <span className={style.text}>{descText ? descText : '限时新人福利'}，</span>
        <span className={style.text2}>
          {discountText ? `${discountText}${discountPercent}%` : `升级立省${discountPercent}%`}
        </span>
      </div>

      {!hideArrow && (
        <img
          className={classNames(style.arrowIcon)}
          src={commonUtils.getStaticFile('new_count_down_right.png')}
        />
      )}
    </section>
  )
})

export default CountDownV2
